import * as types from "../../actionTypes";

export const removeAvatarRequest = (data) => {
  console.log(data);
  return { type: types.REMOVE_JOBSEEKER_AVATAR_REQUEST, payload: data };
};

export const resetRemoveAvatar = () => ({
  type: types.RESET_JOBSEEKER_REMOVE_AVATAR,
});
